import { transformCellValue } from './common.transformers'

export function transformText(
  valueObj,
  rowObj,
  templateField,
  templateFields,
  context,
  dataContainer,
  readOnlyTransform,
) {
  if (readOnlyTransform) return valueObj.cell_value

  const governanceOwner =
    templateField.field.segment_type === 'variable' ? templateField : templateField.field

  let cellValue = valueObj.cell_value

  // todo: why do we run this with the validation option?
  // This is a carry-over from the old transformer
  if (governanceOwner.validation) {
    cellValue = transformCellValue(cellValue, governanceOwner.validation)
  }

  if (governanceOwner.transformation) {
    cellValue = transformCellValue(cellValue, governanceOwner.transformation)
  }

  return cellValue
}
